import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Route
import PrivateRouteAdmin from "./PrivateRouteAdmin";
import PublicRoute from "./PublicRoute";

// admin
import Login from "../Component/admin/login/Login";
import Orders from "../Component/admin/dashboard/Orders";
import OrderType from "../Component/admin/dashboard/ordertype";
// import CanceledOrders from "../Component/admin/dashboard/CancelledOrders";
import DeliveredOrders from "../Component/admin/dashboard/delivered";
// import IntransitOrders from "../Component/admin/dashboard/IntransitOrders";
import AdminDashboard from "../Component/admin/dashboard/Dashboard";
import AdminCustomerTable from "../Component/admin/customer/CustomerTable";
import DeliveryAgentTable from "../Component/admin/DeliveryAgent/DeliveryAgentTable";
import DeliveryAgentProfile from "../Component/admin/DeliveryAgent/DeliveryAgentProfile";
import ProccessingCenters from "../Component/admin/processingAgent/ProccessingCenters";
import ResetPassword from "../Component/common/resetPassword/ResetPassword";
import AdminForgotPassword from "../Component/admin/forgotPassword/ForgotPassword";

import TableDemo from "../Component/admin/totalOrder/TableDemo";
import TotalOrderTable from "../Component/admin/totalOrder/TotalOrder";
import OpenDeliveryRequests from "../Component/admin/dashboard/openDeliveryRequests";
import OrderDetails from "../Component/admin/totalOrder/OrderDetails";
import StoreProfile from "../Component/admin/processingAgent/processingAgentDetails";
import Tableapp from "../Component/admin/processingAgent/table";
import DeliveryAgentTotalOrders from "../Component/admin/DeliveryAgent/DeliveryAgentTotalOrders";
import CustomersDetails from "../Component/admin/customer/CustomersDetails";
// import OrdersDetails from '../Component/admin/dashboard/totalOrderDetails';
import VerificationDAPA from "../Component/admin/verification/verificationDA";
import BidTables from "../Component/admin/DeliveryAgent/BidTables";
import DeliveryAgentTripTable from "../Component/admin/DeliveryAgent/TripTable";
import DeliveryAgentDetails from "../Component/admin/DeliveryAgent/DeliveryAgentDetails";
import ProcessingAgentDetails from "../Component/admin/DeliveryAgent/ProcessingAgentDetails";

import TotalProcessingOrders from "../Component/admin/processingAgent/TotalProcessingOrders";
import AminProfile from "../Component/admin/DeliveryAgent/AminProfile";
import EditProfile from "../Component/admin/DeliveryAgent/EditProfile";
import Notifications from "../Component/admin/totalOrder/Notifications";
import Accounts from "../Component/admin/totalOrder/Accounts";
import PayoutSystem from "../Component/admin/totalOrder/PayoutSystem";
import Settings from "../Component/admin/totalOrder/Settings";
import CreateAdmin from "../Component/admin/totalOrder/CreateAdmin";
import AdminList from "../Component/admin/totalOrder/AdminList";
import TermsConditions from "../Component/admin/totalOrder/TermsConditions";
import Tnc from "../Component/admin/tnc/Tnc";
import EditAdmin from "../Component/admin/totalOrder/EditAdmin";
import PendingDAPA from "../Component/admin/dashboard/Pending";
import OrdersList from "../Component/admin/billing/OrdersList";
import TransferAmount from "../Component/admin/billing/TransferAmount";
import CommissionList from "../Component/admin/commission/CommissionList";
import AccountDelete from "../Component/admin/accountDelete/AccountDelete";
import RouteList from "../Component/admin/route/RouteList";
import RouteDetails from "../Component/admin/route/RouteDetails";
import AddRoute from "../Component/admin/route/AddRoute";
import DeliveryAgentBankDetail from "../Component/admin/DeliveryAgent/DeliveryAgentBankDetail";
import PromotionReferralList from "../Component/admin/promotionReferral/PromotionReferralList";
import CreateReferral from "../Component/admin/promotionReferral/CreateReferral";
import ReferralDetails from "../Component/admin/promotionReferral/referral/ReferralDetails";
import ReferralUsage from "../Component/admin/promotionReferral/referral/ReferralUsage";
import PromoUsage from "../Component/admin/promotionReferral/promotion/PromoUsage";
import PromoDetails from "../Component/admin/promotionReferral/promotion/PromoDetails";
import CreateDiscount from "../Component/admin/promotionReferral/CreateDiscount";
import CustomerReferral from "../Pages/CustomerReferral";
import AgentReferral from "../Pages/AgentReferral";
import CreatePromotion from "../Component/admin/promotionReferral/CreatePromotion";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import OpenDeliveryRequestsDetails from "../Component/admin/dashboard/openDeliveryRequestDetails";
import OrganizationList from "../Component/admin/organization/OrganizationList";
import OrganizationDetails from "../Component/admin/organization/organizationDetails/OrganizationDetails";
import OrdersDetails from "../Component/admin/dashboard/OrderDetails";
import RequestDetails from "../Pages/RequestDetails";
import MapView from "../Pages/MapView";
import InternationalPayout from "../Component/admin/internationalPayout/InternationalPayout";
import PromoPricingList from "../Component/admin/promoPricing/PromoPricingList";
import CreateEditPromoPricing from "../Component/admin/promoPricing/CreateEditPromoPricing";
import PromoPricingDetails from "../Component/admin/promoPricing/PromoPricingDetails";
import PriceRecommendation from "../Component/admin/priceRecommendation/PriceRecommendation";

class DelivaRoute extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
  render() {
    return (
      <>
        <ToastContainer
          autoClose={5000}
          className="custom-toaster-main-cls"
          toastClassName="custom-toaster-bg"
        />
        <Switch>
          <PublicRoute exact path="/" component={Login} />

          {/* <PrivateRouteAdmin path="/admin/orders/:name" component={Orders} /> */}
          <PrivateRouteAdmin path="/orders/:name" component={OrderType} />
          <PrivateRouteAdmin path="/notifications" component={Notifications} />
          <PrivateRouteAdmin path="/Accounts" component={Accounts} />
          <PrivateRouteAdmin path="/PayoutSystem" component={PayoutSystem} />
          <PrivateRouteAdmin path="/settings" component={Settings} />

          <PrivateRouteAdmin
            path="/:name/details/:id"
            component={OrdersDetails}
          />
          <PrivateRouteAdmin
            path="/verification/:id"
            component={VerificationDAPA}
          />

          <PrivateRouteAdmin path="/pending/:id" component={PendingDAPA} />

          <PrivateRouteAdmin
            path="/deliveryPartner/:name/:id"
            component={BidTables}
          />
          <PrivateRouteAdmin
            path="/deliveryPartnerOrders/totalorders/:id"
            component={DeliveryAgentTotalOrders}
          />

          <PrivateRouteAdmin
            path="/deliveryPartnerTrips/totaltrips/:id"
            component={DeliveryAgentTripTable}
          />

          <PrivateRouteAdmin path="/delivered" component={DeliveredOrders} />

          <PrivateRouteAdmin path="/dashboard" component={AdminDashboard} />
          <PrivateRouteAdmin path="/Tableapp" component={Tableapp} />
          <PrivateRouteAdmin
            // path="/customerlist"
            path="/senderList"
            component={AdminCustomerTable}
          />
          <PrivateRouteAdmin
            exact
            // path="/customerDetails"
            path="/senderDetails"
            component={CustomersDetails}
          />
          <PrivateRouteAdmin
            exact
            // path="/customerDetails/:id"
            path="/senderDetails/:id"
            component={CustomersDetails}
          />
          <PrivateRouteAdmin
            // path="/customerDetails"
            path="/senderDetails"
            component={CustomersDetails}
          />
          <PrivateRouteAdmin
            path="/deliveryPartnerList"
            component={DeliveryAgentTable}
          />

          <PrivateRouteAdmin
            path="/deliveryPartnerProfile/bankdatail"
            component={DeliveryAgentBankDetail}
          />

          <PrivateRouteAdmin
            path="/deliveryPartnerProfile"
            component={DeliveryAgentProfile}
          />
          <PrivateRouteAdmin path="/AminProfile" component={AminProfile} />
          <PrivateRouteAdmin path="/EditProfile" component={EditProfile} />
          <PrivateRouteAdmin
            // path="/agent/verify"
            path="/partner/verify"
            component={DeliveryAgentDetails}
          />
          <PrivateRouteAdmin
            path="/processingagent/verify"
            component={ProcessingAgentDetails}
          />
          <PrivateRouteAdmin
            path="/processingagentlist"
            component={ProccessingCenters}
          />
          <PrivateRouteAdmin
            path="/totalprocessingorders"
            component={TotalProcessingOrders}
          />
          <PrivateRouteAdmin path="/totalorder" component={TotalOrderTable} />

          <PrivateRouteAdmin
            path="/opendeliveryrequests"
            component={OpenDeliveryRequests}
          />

          <PrivateRouteAdmin
            path="/billing/orderList/:id"
            component={OrdersList}
          />

          <PrivateRouteAdmin path="/referralList" component={CommissionList} />

          <PrivateRouteAdmin
            path="/billing/orderDetails/:id"
            component={TransferAmount}
          />

          <PrivateRouteAdmin path="/OrderDetails" component={OrderDetails} />
          <PrivateRouteAdmin path="/TableDemo" component={TableDemo} />
          <PrivateRouteAdmin path="/storeprofile" component={StoreProfile} />
          <PrivateRouteAdmin path="/createadmin" component={CreateAdmin} />
          <PrivateRouteAdmin
            path="/editadmin/:type/:userId"
            component={CreateAdmin}
          />
          <PrivateRouteAdmin
            path="/viewadmin/:type/:userId"
            component={CreateAdmin}
          />

          <PrivateRouteAdmin path="/list" component={AdminList} />
          <PrivateRouteAdmin
            path="/termsconditions"
            component={TermsConditions}
          />

          {/* Route flow routes */}
          <PrivateRouteAdmin path="/add-route" component={AddRoute} />
          <PrivateRouteAdmin path="/route-list" component={RouteList} />
          <PrivateRouteAdmin path="/route-details" component={RouteDetails} />

          {/*  Promo and Refferal Routes */}
          <PrivateRouteAdmin
            path="/promotionReferralList"
            component={PromotionReferralList}
          />

          <PrivateRouteAdmin
            path="/internationalPayout"
            component={InternationalPayout}
          />

          <PrivateRouteAdmin
            path="/promoPricingList"
            component={PromoPricingList}
          />
          <PrivateRouteAdmin
            path="/addPromoPricing"
            component={CreateEditPromoPricing}
          />
          <PrivateRouteAdmin
            path="/editPromoPricing"
            component={CreateEditPromoPricing}
          />
          <PrivateRouteAdmin
            path="/promoPricingDetails/:id"
            component={PromoPricingDetails}
          />
          <PrivateRouteAdmin
            path="/promoPricingAnalytics/:id"
            component={PromoPricingDetails}
          />

          <PrivateRouteAdmin
            path="/price-recommendation"
            component={PriceRecommendation}
          />

          <PrivateRouteAdmin
            path="/organizationList"
            component={OrganizationList}
          />

          <PrivateRouteAdmin
            path="/organizationDetails/:id"
            component={OrganizationDetails}
          />

          <PrivateRouteAdmin
            path="/referralDetails/:id"
            component={ReferralDetails}
          />
          <PrivateRouteAdmin
            path="/opendeliveryrequestsdetails/:id"
            component={OpenDeliveryRequestsDetails}
          />
          <PrivateRouteAdmin
            path="/referralUsage/:id"
            component={ReferralUsage}
          />
          <PrivateRouteAdmin
            path="/promoDetails/:id"
            component={PromoDetails}
          />
          <PrivateRouteAdmin path="/promoUsage/:id" component={PromoUsage} />
          <PrivateRouteAdmin path="/addPromotion" component={CreatePromotion} />
          <PrivateRouteAdmin path="/addReferral" component={CreateReferral} />
          <PrivateRouteAdmin
            path="/createDiscount"
            component={CreateDiscount}
          />
          <PrivateRouteAdmin
            path="/editPromotion"
            component={CreatePromotion}
          />
          <PrivateRouteAdmin path="/editRefferal" component={CreateReferral} />

          <PrivateRouteAdmin
            path="/copyPromotion"
            component={CreatePromotion}
          />
          <PrivateRouteAdmin path="/copyRefferal" component={CreateReferral} />

          {/* public Routes */}
          <PublicRoute path="/tnc" component={Tnc} />
          <PublicRoute path="/account-info" component={AccountDelete} />
          <PublicRoute path="/login" component={Login} />
          <PublicRoute path="/resetpassword" component={ResetPassword} />
          <PublicRoute path="/forgotpassword" component={AdminForgotPassword} />
          <PublicRoute path="/sender-referral" component={CustomerReferral} />
          <PublicRoute path="/partner-referral" component={AgentReferral} />
          <PublicRoute path="/requestDetails/:id" component={RequestDetails} />
          <PublicRoute path="/map-view" component={MapView} />
        </Switch>
      </>
    );
  }
}
export default withRouter(DelivaRoute);
